import "./HeavyUpConfirmationPage.scss";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../../components/ui/StickyHeader";
import SiteFooter from "../../components/ui/SiteFooter";
import { findPlanById } from "./heavyUpContent";

const HeavyUpConfirmationPage = () => {
	const [searchParams] = useSearchParams();
	const [enrollment, setEnrollment] = useState(null);

	useEffect(() => {
		window.scrollTo(0, 0);

		// JotForm's "Thank You" redirect can echo the submitted package/retailer
		// back as query params (e.g. ?plan={package}&retailer={dealershipName}).
		// Prefer that — it survives even if localStorage was cleared or blocked —
		// and fall back to what we stashed in localStorage right before submit.
		const planFromUrl = searchParams.get("plan");
		const retailerFromUrl = searchParams.get("retailer");

		if (planFromUrl) {
			setEnrollment({
				planId: planFromUrl,
				retailer: retailerFromUrl ?? "",
			});
			return;
		}

		const saved = localStorage.getItem("heavyUpEnrollment");
		if (saved) {
			setEnrollment(JSON.parse(saved));
		}
	}, [searchParams]);

	useEffect(() => {
		return () => {
			localStorage.removeItem("heavyUpEnrollment");
		};
	}, []);

	const plan = findPlanById(enrollment?.planId);

	return (
		<div className="heavy-up-page">
			<Header />

			<div className="hu-confirm-section global-padding">
				<span className="hu-confirm-rule" aria-hidden="true" />
				<p className="hu-confirm-eyebrow">Enrollment Submitted</p>
				<h1 className="hu-confirm-title">
					Your Heavy Up enrollment has been submitted
				</h1>
				<p className="hu-confirm-body">
					Thank you. Your Constellation team will contact you to
					discuss the specific needs of your store, media tactics, and
					next steps.
				</p>

				<div className="hu-confirm-summary">
					<p className="hu-confirm-summary__title">
						Enrollment Summary
					</p>
					<div className="hu-confirm-summary__row">
						<span>Selected Plan</span>
						<span>{plan?.title ?? "—"}</span>
					</div>
					<div className="hu-confirm-summary__row">
						<span>Retailer</span>
						<span>{enrollment?.retailer || "—"}</span>
					</div>
					<div className="hu-confirm-summary__row">
						<span>Monthly Investment</span>
						<span className="hu-confirm-summary__amount">
							{plan?.price ?? "—"}
						</span>
					</div>
				</div>

				<p className="hu-confirm-questions">
					Questions?{" "}
					<a href="mailto:jlr@helloconstellation.com">
						jlr@helloconstellation.com
					</a>
				</p>
			</div>

			<SiteFooter dark>
				<p>Land Rover Heavy Up Program</p>
				<p>Program support: jlr@helloconstellation.com</p>
			</SiteFooter>
		</div>
	);
};

export default HeavyUpConfirmationPage;
